/**
 * File visibility levels
 */
export enum FileVisibility {
	PUBLIC = "PUBLIC",
	PRIVATE = "PRIVATE",
}
